import {initVCustomValidation} from "./init";

$(function () {
    let validForm = $('body .form-validate-jquery'),
        formErrors = validForm.find('.form-errors').val();

    // Initialize
    Init.initVCustomValidation();

    // Show validation errors if form errors field exists
    if (formErrors !== undefined && formErrors !== '') {
        showValidationErrors(JSON.parse(formErrors), validForm);
    }

    // validate form if it has
    $(document).on('click', '.modal-form-submit', function () {
        customValidate($(this).closest('form'));
    });
});

/**
 * Form validation
 *
 * @param selector
 */
export function customValidate(selector) {
    selector.validate({
        ignore: 'input[type=hidden], .select2-input', // ignore hidden fields
        errorClass: 'validation-error-label',
        successClass: 'validation-valid-label',
        highlight: function (element, errorClass) {
            $(element).removeClass(errorClass);
        },
        unhighlight: function (element, errorClass) {
            $(element).removeClass(errorClass);
        },
        // Different components require proper error label placement
        errorPlacement: function (error, element) {
            errorPlacement(error, element);
        },
        validClass: 'validation-valid-label',
        success: function (label) {
            if (label.parent('div').find('input').hasClass('styled-checkbox')) {
                label.parent('div').removeClass('has-error');
                label.remove();
            } else {
                label.parents('.field').removeClass('has-error');
                label.remove();
            }
        },
        rules: setRules(selector)
    });
}

/**
 * Place input fields errors
 *
 * @param error
 * @param element
 */
function errorPlacement(error, element) {
    let parentField = element.closest('.field');

    // Styled checkboxes, radios, bootstrap switch
    if (element.hasClass('styled-checkbox')) {
        if (element.parent('div').hasClass('checkbox-inline') || element.parent('div').hasClass('radio-inline')) {
            error.appendTo(element.parent().parent().parent().parent());
        } else {
            error.appendTo(element.parent('div'));
        }
    }

    else if (parentField.find('.input_help').length) {
        error.insertAfter(parentField.find('.input_help'));
    }

    // Input with icons
    else if (element.parents('div').hasClass('has-feedback')) {
        error.appendTo(element.parent());
    }

    // Select2
    else if (parentField.find('.select2').length) {
        error.insertAfter(parentField.find('.select2'));
    }

    // Text input with fitted element
    else if (parentField.find('.labeled-input').length) {
        error.insertAfter(parentField.find('.labeled-input'));
    }

    // Table element
    else if (parentField.find('.table-element').length) {
        error.insertAfter(parentField.find('.table-element'));
    }

    // Input group, styled file input
    else if (element.parent().hasClass('uploader') || element.parents().hasClass('input-group')) {
        error.appendTo(element.parent().parent());
    } else {
        error.insertAfter(element);
    }

    // Add error class to form group
    if (element.hasClass('styled-checkbox')) {
        element.parent('div').addClass('has-error');
    } else {
        parentField.addClass('has-error');
    }

    parentField.find('.help-block').remove();
}

/**
 * Show validation errors
 *
 * @param errors
 * @param container
 */
function showValidationErrors(errors, container) {
    $.each(errors, function (name, message) {
        let element = container.find('[name=' + name + ']');

        errorPlacement(
            $('<label id="'+ element.attr('id') +'" class="validation-error-label">' + message + '</label>'),
            element
        );
    });
}

/**
 * Remove block errors
 *
 * @param container
 */
export function removeError(container) {
    container.removeClass('has-error').find('.help-block').remove();
}

/**
 * Set additional field rules
 *
 * @param selector
 * @returns {{}}
 */
function setRules(selector) {
    let rules = {};

    selector.find('input[class*="required:"], select[class*="required:"]').each(function () {
        let _this = $(this);

        rules[_this.attr('name')] = {required: _this.attr('class').match(/required:\S*/)[0].replace('required:','')};
    });

    return rules;
}
